// utils/constants.ts
export const CACHE_KEY = "bexpress_companyDataCache";
export const CACHE_EXPIRY_KEY = "bexpress_companyDataCacheExpiry";

// por defecto: 1 hora (ajusta si quieres)
export const CACHE_DURATION_MS = 3600 * 1000;

export const DB_NAME = "OrdersDatabase";
export const DB_VERSION = 1;
export const DB_STORE_ORDERS = "orders";
